angular.module('contactModule').component('tourExpert', {
	templateUrl: 'tourExpert/tourExpert.html',
	bindings: {
	}, 
	controller: ['$element', function($element) {
		var ctrl = this;

		this.$onInit = () => {
	
		}; 

		this.$postLink = () => {
	 
		};



	}]
});